import script from "./PlayAnim.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayAnim.vue?vue&type=script&setup=true&lang=js"

import "./PlayAnim.vue?vue&type=style&index=0&id=37812314&lang=css"

const __exports__ = script;

export default __exports__